import { jsx as _jsx } from "react/jsx-runtime";
export default function Img(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
      onLoad = _ref.onLoad;
  return /*#__PURE__*/_jsx("img", {
    width: width,
    height: height,
    className: className,
    src: src,
    alt: alt,
    loading: loading,
    onLoad: onLoad
  });
}